import classNames from 'classnames';

import Button from 'components/partials/button/button';

export interface GoalContactItemProps {
  variant?: 'standalone' | 'monitoring';
}

const GoalContactItem = ({
  variant = 'standalone',
}: GoalContactItemProps): React.JSX.Element => {
  const handleEmailClick = (): void => {
    window.location.href = 'mailto:clientsupport@marketviewedu.com';
  };

  return (
    <div
      className={classNames(
        'w-full bg-navy-800 text-white rounded-md flex flex-col items-center',
        variant === 'monitoring' ? 'p-5 mt-6' : 'py-8 px-4 mt-10'
      )}
      data-testid="goal-contact-item"
    >
      <h2 className="text-xl font-bold mb-2" data-testid="goal-contact-heading">
        Are your goals missing?
      </h2>
      <p className="mb-4 text-navy-100" data-testid="goal-contact-description">
        Contact your Client Success Team to discuss your priorities and ensure
        your goals are fully aligned and up to date.
      </p>
      <Button
        variant="brand-filled"
        size="sm"
        onClick={handleEmailClick}
        data-testid="goal-contact-button"
      >
        {variant === 'monitoring' ? 'Speak with Us' : 'Speak to Us'}
      </Button>
    </div>
  );
};

export default GoalContactItem;
